import { S as Swiper } from './swiper-core-DH3mE4MZ.js';
import { N as Navigation } from './navigation-hpH59l-7.js';
import { A as A11y } from './a11y-DWSxD09z.js';
import './create-element-if-not-defined-DmoqEVgJ.js';

class ShopTheLook extends HTMLElement {
  swiper = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');
  slideCount = this.swiper.querySelectorAll('.swiper-slide').length;

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation],
      slidesPerView: this.slideCount > 2 ? 1.4 : 2,
      spaceBetween: 1,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: this.slideCount > 4 ? 3.2 : 4,
        },
        1024: {
          slidesPerView: this.slideCount > 4 ? 3.6 : 4,
        },
      },
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);
